/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import QtmColor from './Color';
import common from './common';

const yellow: QtmColor = {
  50: '#fdf8e2',
  100: '#f9ebb6' /* light */,
  200: '#f6df87',
  300: '#f4d459',
  400: '#f2c93a',
  500: '#f0c029',
  600: '#f0b323' /* primary */,
  700: '#efa11e',
  800: '#ef911a' /* dark */,
  900: '#ed7514',
  contrast: {
    50: common.black,
    100: common.black,
    200: common.black,
    300: common.black,
    400: common.black,
    500: common.black,
    600: common.black,
    700: common.black,
    800: common.black,
    900: common.black,
  },
};

export default yellow;
